/// <amd-module name="SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent" />
import * as  React from "react";
import { SearchResultItemProps } from "SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent.Props";

import "VSS/LoaderPlugins/Css!SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent";

export const SearchResultItemComponent: React.StatelessComponent<SearchResultItemProps> = (props: SearchResultItemProps) => {

    return (
        < div className="result-container flex" >
            {!!props.imageComponent &&
                <div className="image-container">
                    {props.imageComponent}
                </div>
            }
            <div className="summary-container flex-grow">
                <div className="result-title-container flex">
                    <div className="search-result-title">
                        {props.titleComponent}
                    </div>
                    {!!props.titleMetaDataComponent &&
                        <div className="title-metadata-container flex">
                            {props.titleMetaDataComponent}
                        </div>
                    }
                </div>
                {!!props.subTitleComponent &&
                    <div className="result-sub-title">
                        {props.subTitleComponent}
                    </div>
                }
                <div className="result-description">
                    {props.descriptionComponent}
                </div>
                {!!props.tagsComponent &&
                    <div>
                        {props.tagsComponent}
                    </div>
                }
            </div>
            {!!props.resultRightSectionComponent &&
                <div className="result-right-section">
                    {props.resultRightSectionComponent}
                </div>
            }
        </div>
    );
}